export type SocketPayload = object | string | number | boolean | null;

/**
 * Minimum player level that unlocks the paid in-game mini games.
 *
 * v1 read this from the platform settings (`minimal_level_for_games`) and derived
 * `payToPlay` as `svarka_level >= minimal_level_for_games`. The v2 backend still
 * serves that setting — `getSvaraGameSettings()` in
 * trinity-nest/apps/game-view/src/svara/svara-view.service.ts — but nothing in
 * this app fetches it yet, so the value is mirrored here. Keep the two in step;
 * see also the unused LevelConfig.MIN_LEVEL_FOR_GAMES in the backend, which
 * disagrees at 15 and is dead code.
 */
export const PAY_TO_PLAY_MIN_LEVEL = 10;

export interface GameTableProps {
	tableId?: number | string;
	legacyRoomId?: number;
	roomSlug?: string;
	isTutorial?: boolean;
	onGameEvent?: (event: string, data?: SocketPayload) => void;
	isTournamentRoom?: boolean;
	isDuel?: boolean;
	hostApiRef?: React.MutableRefObject<GameHostApi | null>;
}

export type GameHostApi = {
	toggleSound: () => void;
	openSettings: () => void;
};

export interface GameInitData {
	userId?: number;
	tableId?: string | number;
	width: number;
	height: number;
	ownerId?: string | number;
	tutorial: boolean;
	isVipRoom: boolean;
	isTournamentRoom: boolean;
	isDuelRoom: boolean;
	tableLevel: number;
	playerName?: string;
	soundEnabled: boolean;
	translations: Record<string, string>;
	language: string;
	drawingBuffer: boolean;
	payToPlay: boolean;
	freeToPlay: boolean;
	payToPlayMinLevel: number;
	token?: string;
	api: {
		game: string;
		user: string;
	};
	eventRunning: string;
	isEventRunning: boolean;
	powerMeter: boolean;
	/**
	 * Helix analytics config for the embedded game (see gameHelixConfig).
	 * Absent or keyless leaves the game's tracker off; `perf: true` enables
	 * its performance telemetry (dev/stage only).
	 */
	helix?: {
		url: string;
		projectId: string;
		writeKey: string;
		perf?: boolean;
	};
}
